import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=1ddd3b1e&scoped=true&"
import script from "./OrderDetails.vue?vue&type=script&lang=js&"
export * from "./OrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetails.vue?vue&type=style&index=0&id=1ddd3b1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddd3b1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3769141042/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ddd3b1e')) {
      api.createRecord('1ddd3b1e', component.options)
    } else {
      api.reload('1ddd3b1e', component.options)
    }
    module.hot.accept("./OrderDetails.vue?vue&type=template&id=1ddd3b1e&scoped=true&", function () {
      api.rerender('1ddd3b1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/OrderDetails.vue"
export default component.exports